import type { ErrorContext } from './trackDatadogError';

export const DATADOG_SITE = 'datadoghq.eu';
export const DATADOG_SERVICE = 'web-react-panorama';
export const DATADOG_TEAM = 'panorama';
export const DATADOG_REGION = 'eu';

export const DEFAULT_SESSION_SAMPLE_RATE = 100;
export const DEFAULT_SESSION_REPLAY_SAMPLE_RATE = 50;

/**
 * Environments where Datadog is expected to be off (no credentials). Anything
 * else is a deployed environment where missing credentials is a real incident.
 */
export const LOCAL_ENVIRONMENTS = ['development', 'test'];

/** Logged when Datadog is intentionally off in local development. */
export const DATADOG_DISABLED_LOCAL_MESSAGE =
  'Datadog is disabled: credentials not set (expected in local development).';

/**
 * Logged at `error` level when Datadog cannot initialize in a deployed
 * environment — credentials are missing and frontend errors will go unreported.
 */
export const DATADOG_MISCONFIGURED_MESSAGE =
  '[observability] Datadog is NOT initialized in a deployed environment: VITE_DATADOG_APP_ID / VITE_DATADOG_CLIENT_TOKEN are missing. Frontend errors will NOT be reported.';

/** Datadog context for errors caught during application bootstrap. */
export const BOOTSTRAP_ERROR_CONTEXT: ErrorContext = {
  source: 'bootstrap'
};
